import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import styles from './pop-up.module.scss';

const PopUp = ({ showModal, showModalP, setShowModal, size, children, style }) => {


  const sizeStyles = {
    small: styles.smallSize,
    medium: styles.mediumSize,
    large: styles.largeSize,
  };

  const ref = useRef();

  const handleOverlayClick = (e) => {
    if (ref.current === e.target) {
      setShowModal(false);
      localStorage.removeItem('step');
      localStorage.removeItem('nameRestaurant');
      localStorage.removeItem('rucRestaurant');
      localStorage.removeItem('aliasRestaurant');
      localStorage.removeItem('nameUser');
      localStorage.removeItem('wspUser');
      localStorage.removeItem('emailUser');
    }
  };

  // Event listeners
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && showModal) {
        setShowModal(false);
      }
    },
    [showModal, setShowModal],
  );

  useEffect(() => {
    document.addEventListener('keydown', keyPress);
    return () => document.removeEventListener('keydown', keyPress);
  }, [keyPress]);

  // Render
  if (!showModal) return null;

  return createPortal(
    <div className={styles.overlay} onClick={handleOverlayClick} ref={ref}>
      <div className={`${style ? styles.wrapperLoc : styles.wrapper} ${sizeStyles[size] || sizeStyles.medium}`}>
        <div>{children}</div>
      </div>
    </div>,
    document.body
  );
};

PopUp.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
};

export default PopUp;
